export const enum KycStatus {
    Empty = 'empty',
    Processing = 'processing',
    Validated = 'validated',
}